export default "__VITE_ASSET__2XJ$37by__"